/* @flow */

import * as React from 'react';

import ErrorBoundry from 'src/shared/app/base/component/error/ErrorBoundry';
import { mainContentId } from 'src/shared/app/nav/settings/navSettings';

import useMounted from 'src/shared/app/base/hook/useMounted';
import NotificationPortal from 'src/shared/app/base/portal/notification/NotificationPortal';
import UtilityPortal from 'src/shared/app/base/component/template/component/UtilityPortal';

type Props = {
  layoutClass?: string,
  children: React.Node,
};

const MainSwitch = ({ layoutClass, children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */
  const isMounted = useMounted();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const notificationPortal = isMounted && <NotificationPortal />;

  return (
    <main className={layoutClass} id={mainContentId}>
      <UtilityPortal />
      {notificationPortal}
      <ErrorBoundry>{children}</ErrorBoundry>
    </main>
  );
};

export default React.memo<Props>(MainSwitch);
